// extracted by mini-css-extract-plugin
export default {"section":"Section_section__Z2PLw"};